module.exports = __webpack_public_path__ + "static/media/icon_check.f5155a6f.svg";